import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import EditableSection from 'components/v2/EditableSection';
import Select from 'components/v2/select';

const Commercial = ({ data, onUpdateCarrier, className }) => {
  const { t } = useTranslation();
  const [initialData, setInitialData] = useState({});
  const [commercialData, setCommericalData] = useState({});

  const getInitData = () => {
    if (data) {
      setInitialData(data);
      setCommericalData(data);
    }
  };
  useEffect(() => {
    getInitData();
  }, [data]);

  const onChange = (field, value) => {
    setCommericalData((prev) => ({ ...prev, [field]: value }));
  };
  const handleSave = async () => {
    const updates = {};
    const { ...changed } = commercialData;
    Object.keys(changed).forEach((key) => {
      if (initialData[key] !== changed[key]) {
        updates[key] = changed[key];
      }
    });
    if (Object.keys(updates).length) {
      await onUpdateCarrier(updates);
    }
  };
  const handleAfterSave = (onSaveSuccess) => {
    return (updatedData = {}) => {
      setInitialData((prev) => ({ ...prev, ...updatedData }));
      onSaveSuccess();
    };
  };
  return (
    <EditableSection
      title={t('COMMERCIAL')}
      className={classNames(className)}
      canEdit
    >
      {(editing, saving, onSaveSuccess, onSaveFail) =>
        !editing ? (
          <CommercialSummary fields={initialData} />
        ) : (
          <CommercialForm
            fields={commercialData}
            onChange={onChange}
            onSaveCarrier={() => handleSave()}
            saving={saving}
            onSaveSuccess={handleAfterSave(onSaveSuccess)}
            onSaveFail={onSaveFail}
          />
        )
      }
    </EditableSection>
  );
};

const CommercialSummary = ({ fields = {} }) => {
  const { t } = useTranslation();
  const { capacity_rate_manager } = fields;
  const na = t('NONE');
  return (
    <div className="grid grid-cols-1 gap-4">
      <DescriptionListItem label={t('CAPACITY_RATE_MANAGER')}>
        {capacity_rate_manager || na}
      </DescriptionListItem>
    </div>
  );
};

const CommercialForm = ({
  fields,
  onChange,
  saving,
  onSaveCarrier,
  onSaveSuccess,
  onSaveFail,
}) => {
  const { t } = useTranslation();
  const saveForm = async () => {
    try {
      await onSaveCarrier();
      onSaveSuccess(fields);
    } catch (e) {
      onSaveFail();
    }
  };
  useEffect(() => {
    if (saving) {
      saveForm();
    }
  }, [saving]);
  const { admins } = fields;
  return (
    <div className="grid gap-4">
      <Select
        items={admins}
        valueKey="slug"
        textKey="name"
        selected={fields.capacity_rate_manager}
        onSelect={({ slug }) => onChange('capacity_rate_manager', slug)}
        info={t('CAPACITY_RATE_MANAGER_REPRESENTATIVE')}
        label={t('CAPACITY_RATE_MANAGER')}
        inputClassNames="lg:w-4/5 w-1/2"
      />
    </div>
  );
};

export default Commercial;
